import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { BRAND_ASSETS } from '../../config/assets';
import './Navbar.css';

export default function Navbar() {
      const [scrolled, setScrolled] = useState(false);
      const [menuOpen, setMenuOpen] = useState(false);
      const location = useLocation();
      const { language, pathFor, languagePath, t } = useLanguage();

      useEffect(() => {
            const handleScroll = () => setScrolled(window.scrollY > 20);
            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
      }, []);

      useEffect(() => {
            setMenuOpen(false);
      }, [location]);

      return (
            <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
                  <div className="navbar__inner">
                        <Link to={pathFor('home')} className="navbar__brand">
                              <img src={BRAND_ASSETS.logo} alt="AgroLlama" className="navbar__logo" />
                              <span className="navbar__brand-text">AgroLlama</span>
                        </Link>

                        <div className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
                              <Link to={pathFor('home')} className={`navbar__link ${location.pathname === pathFor('home') ? 'navbar__link--active' : ''}`}>{t('navbar.home')}</Link>
                              <Link to={pathFor('privacy')} className={`navbar__link ${location.pathname === pathFor('privacy') ? 'navbar__link--active' : ''}`}>{t('navbar.privacy')}</Link>
                              <Link to={pathFor('terms')} className={`navbar__link ${location.pathname === pathFor('terms') ? 'navbar__link--active' : ''}`}>{t('navbar.terms')}</Link>
                              <Link to={pathFor('support')} className={`navbar__link ${location.pathname === pathFor('support') ? 'navbar__link--active' : ''}`}>{t('navbar.support')}</Link>
                              <div className="navbar__lang-switcher">
                                    <Link
                                        to={languagePath('kz')}
                                        hrefLang="kk-KZ"
                                        className={`navbar__lang-btn ${language === 'kz' ? 'navbar__lang-btn--active' : ''}`}
                                    >
                                          KZ
                                    </Link>
                                    <Link
                                        to={languagePath('ru')}
                                        hrefLang="ru"
                                        className={`navbar__lang-btn ${language === 'ru' ? 'navbar__lang-btn--active' : ''}`}
                                    >
                                          RU
                                    </Link>
                                    <Link
                                        to={languagePath('en')}
                                        hrefLang="en"
                                        className={`navbar__lang-btn ${language === 'en' ? 'navbar__lang-btn--active' : ''}`}
                                    >
                                          EN
                                    </Link>
                              </div>
                        </div>

                        <button
                              className={`navbar__burger ${menuOpen ? 'navbar__burger--open' : ''}`}
                              onClick={() => setMenuOpen(!menuOpen)}
                              aria-label="Toggle menu"
                        >
                              <span /><span /><span />
                        </button>
                  </div>
            </nav>
      );
}
